import { BaseListFilter } from '../../../models/base-list-filter.model';

export class FacilitiesFilter extends BaseListFilter {
  createdAtFrom?: Date;
  createdAtTo?: Date;
  active?: boolean;
  search?: string;

  constructor() {
    super();
  }
}
